import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  Link,
  Outlet,
  useRouter,
  type ErrorComponentProps,
} from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { uk } from '@/i18n/uk';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
});

/** Неочікувана помилка рендеру або завантаження сторінки. */
function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <div
      role="alert"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-8 text-center"
    >
      <h1 className="text-xl font-semibold">{uk.common.error}</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {error instanceof Error ? error.message : String(error)}
      </p>
      <Button
        variant="outline"
        onClick={() => {
          reset();
          void router.invalidate();
        }}
      >
        {uk.common.retry}
      </Button>
    </div>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold">{uk.notFound.title}</h1>
      <Button asChild variant="outline">
        <Link to="/">{uk.notFound.back}</Link>
      </Button>
    </div>
  );
}
